<template>
  <div class="modal fade" id="ConfirmMsgModal" data-backdrop="static">
    <div class="modal-dialog confirm-modal-wrapper">
      <div class="modal-content expiry-modal-content">
        <div class="modal-header">
          <!-- <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">&times;</span>
          </button> -->
          <div class="card text-center">
            <div class="card-body">
              <div class="card-title">
                <p class="first-card-title update-failed">{{confirmMessage}}</p>
              </div>
              <div class="card-text">
                <p class="confirm-message">By discarding the changes will not save.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <button
                  class="btn btn-block emergo-white-button"
                  @click="closePopup(false)"
                >Cancel</button>
              </div>
              <div class="col-lg-6">
                <button
                  class="btn btn-block emergo-blue-button"
                  @click="closePopup(true)"
                >OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: ['confirmMessage'],
  data() {
    return {

    };
  },
  methods: {
    closePopup(closeParent) {
      $('#ConfirmMsgModal').modal('hide');
      // if (closeParent) {
      this.$emit('closePopup', closeParent);
      // }
    },
  },

};
</script>

<style lang="scss" scoped>
.modal-open {
	.modal {
		overflow: hidden;
	}
}
.modal {
	.modal-dialog {
		.modal-content {
			border-radius: $radius10;
			.modal-header {
				background: #f2f2f2;
				border-radius: $radius10;
			}
		}
	}
}
.card {
	.card-body {
		.card-title {
			p {
				&.first-card-title {
					font-size: 25px;
					padding-top: 30px;
					color: $dark-black-alpha;
					font-weight: $font-weight-medium;
				}
			}
		}
		.card-text {
			p {
				&.first-card-text {
					padding-top: 30px;
          @include fontItems($font-18, 19px, $font-weight-small);
					margin-bottom: 0px;
					color: $dark-black-alpha;
				}
			}
		}
	}
}
img {
	&.expiry_logo {
		&.card-img-top {
			width: 50px;
			height: 50px;
		}
	}
}
.confirm-message {
	padding-top: 10px;
	padding-bottom: 20px;
	color: $dark-black-alpha;
  @include fontItems($font-18, 28px, $font-weight-small);
}
.modal-dialog {
	margin: 20px auto;
}
@media screen and (min-width: 768px) {
  .confirm-modal-wrapper{
    width: 500px;
  }
}
</style>
